import {useSelector} from "react-redux";
import {useJwtClaim} from "crqlar-react-common/dist/utils/hooks/admin/useAuthorizedViaAdmin";

/** Production accounts that get the agent; separate from the pilot set in `useAuthorizedViaAdmin`. */
const AGENT_USER_IDS = new Set([
    // FHG (Forsthofgut)
    "66ed55b91c12714d827ec458",
]);

/** The agent is open to everyone on these hosts. Keyed on the host, not an env var: a new staging domain needs a line here. */
export const isNonProductionHost = (hostname: string): boolean =>
    hostname === "localhost"
    || hostname === "127.0.0.1"
    || hostname.endsWith(".localhost")
    || hostname.startsWith("sandbox-");

/** Gates the "Show agent" button and the panel; admin login-as sessions also get it in production. */
export const useAutomationAgentEnabled = (): boolean => {
    const authorizedBy = useJwtClaim("authorizedBy");
    const userId = useSelector<any, string | undefined>(state => state.auth.user?.id);

    if (isNonProductionHost(window.location.hostname)) return true;

    return authorizedBy === "admin" || (userId != null && AGENT_USER_IDS.has(userId));
};
